import { Link as GatsbyLink } from 'gatsby'
import type { GatsbyLinkProps } from 'gatsby-link'
import React from 'react'
import { getLinkTarget, getValidUrl } from '../../helpers/url'

interface LinkProps
  extends Omit<GatsbyLinkProps<Record<string, unknown>>, 'ref'> {
  withoutSlider?: boolean
}

// Since DOM elements <a> cannot receive activeClassName
// and partiallyActive, destructure the prop here and
// pass it only to GatsbyLink
const Link = ({
  children,
  to,
  activeClassName,
  partiallyActive,
  withoutSlider,
  ...other
}: LinkProps): JSX.Element => {
  const link = getValidUrl(to)
  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const internal = /^\/(?!\/)/.test(link)
  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <GatsbyLink
        to={link}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}
      >
        {children}
      </GatsbyLink>
    )
  }
  return (
    <a
      href={link}
      rel='noopener noreferrer'
      target={getLinkTarget(link)}
      {...other}
    >
      {children}
    </a>
  )
}
export default Link
